import React, { useEffect, useState } from 'react';
import axios from 'axios';
import dayjs from "dayjs";
import Calendar from '../calendar/Calendar.js';
import ChartHistory_InverterPower from '../chart/ChartHistory_InverterPower';

import ModalLoad from '../modal/ModalLoad';
import ModalPopupMessage from '../modal/ModalPopupMessage';

function HistoricalDataInverterPower(props) {
    const [reportsite, setReportsite] = useState('-');
    const [data_uioption, setData_uioption] = useState({
        device_selector: [],
    });
    const [inverter_item, setInverter_item] = useState({
        inverter_id_text: 'INV-01',
        device_name: 'inv-01',
        pvstring_support: 8
    });

    const [string_tag_list, setString_tag_list] = useState([])
    const [chart_select, setChart_select] = useState({
        datakey: 'active_power',
        display: 'AC Power'
    });
    const [chart_select_export, setChart_select_export] = useState({
        datakey: '',
        display: ''
    });
    const [reportdate_dt, setReportdate_dt] = useState(dayjs(new Date()));

    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });

    const onCalendaraChange = (date, dateString) => {
        setReportdate_dt(date)
    };

    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    useEffect(() => {
        return () => {
            setString_tag_list([])
            setChart_plot({})
        };
    }, []);

    useEffect(() => {
        if (reportsite !== "-") {
            if (props.permitdata.view_mode === "center") {
                api_getmeu()
            }
        }
    }, [reportsite, props.permitdata]);

    useEffect(() => {
        if (props.permitdata !== null && props.permitdata !== undefined) {
            if (props.permitdata.sitescope_arr !== null && props.permitdata.sitescope_arr !== undefined) {
                setReportsite(props.permitdata.sitescope_arr[0].sitecode_txt)
            }
        }
    }, [props.permitdata]);

    useEffect(() => {
        if (props.data_uioption !== null && props.data_uioption !== undefined) {
            if (props.data_uioption.device_selector !== undefined && props.data_uioption.device_selector !== null) {
                const found = data_uioption.device_selector.find((element) => element.device_name_raw === "inv-01");
                if (found !== undefined) {
                    setData_uioption({
                        inverter_id_text: found.device_id,
                        device_name: found.device_name,
                        pvstring_support: found.pvstring_support
                    })
                }
                setData_uioption(props.data_uioption)
            }
        }
    }, [props.data_uioption]);

    useEffect(() => {
        let temp_tag = []
        temp_tag.push({ table: 'Inverter', tagname: 'active_power', display: 'AC Power', value: false, unit: 'kW', index: 0, channel: 0 })
        temp_tag.push({ table: 'Inverter', tagname: 'mppt_power', display: 'DC Power (Mppt)', value: false, unit: 'kW', index: 0, channel: 0 })
        for (let i = 0; i < 28; i++) {
            const channel = (i + 1)
            temp_tag.push({ table: 'PV String', tagname: 'pv_' + channel + '_p', display: 'PV' + channel + ' Power', value: false, unit: 'kW', index: i, channel: channel })
        }
        setString_tag_list(temp_tag)
    }, []);

    function disabledCalendar(current) {
        return current.isBefore(props.permitdata.cod_date, 'day') || current.isAfter(dayjs(new Date()).format("YYYY-MM-DD 23:59:59"), 'day')
    }

    const [chart_plot, setChart_plot] = useState({
        FileName: '',
        CSV_Data: [],
        XLabel: '',
        Sitename: '-',
        Power: [],
        IRR: [],
        Tags: '-',
        Device: '-',
        Chart1_Style: {
            irr_type: "line",
            solar_type: "area",
            irr_unit: "W/m2",
            solar_unit: "kW",
            axis_y1: 'Power (kW)',
            axis_y2: 'Irradiation (W/m2)',
            xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: '-'
        }
    });

    async function api_query() {
        if (inverter_item.inverter_id_text !== "-" && inverter_item.inverter_id_text !== "" && chart_select.datakey !== "") {
            let dt = dayjs(new Date(reportdate_dt)).format("YYYY-MM-DD")

            setmodal_load({ enable: true, message: "Query historical inverter power." })
            await sleep(500)

            const formData = new FormData()
            formData.append('post_url', "/proxy/center/api/historical/rawdata")
            formData.append('token', props.permitdata.token)

            formData.append('reportdate', dt)
            formData.append('taglist', "env.total_irr_avg#" + inverter_item.device_name + "." + chart_select.datakey + "#" + inverter_item.device_name + ".conn")
            formData.append('validate', "all")
            if (props.permitdata.view_mode === "local") {
                formData.append('sitecode', props.permitdata.sitecode)
            } else {
                formData.append('sitecode', reportsite)
            }

            axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/historical/rawdata", formData, {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'multipart/form-data;',
                    "Authorization": "Bearer " + props.permitdata.token
                },
            })
                .then((response) => {
                    setmodal_load({ enable: false, message: "" })
                    if (response.data.status === 'OK') {
                        setChart_select_export(chart_select)
                        if (response.data.tabledata !== null) {
                            let arr1 = []
                            let arr2 = []
                            for (let i = 0; i < response.data.tabledata.length; i++) {
                                const dx = new Date(response.data.tabledata[i].timestamp)

                                arr1.push({ x: dx, y: response.data.tabledata[i]["env.total_irr_avg"] })
                                arr2.push({ x: dx, y: response.data.tabledata[i][inverter_item.device_name + "." + chart_select.datakey] })
                            }
                            setChart_plot({
                                ...chart_plot,
                                FileName: response.data.filename,
                                CSV_Data: response.data.tabledata,
                                Sitename: response.data.sitename,
                                IRR: arr1,
                                Power: arr2,
                                XLabel: response.data.xlabel,
                                Tags: chart_select.display,
                                Device: inverter_item.inverter_id_text,
                            })
                        }
                    }
                    else {
                        reset_chart()
                        setModal_popup({
                            modaltype: 'modal-error',
                            headers: 'Error',
                            message: response.data.message,
                            enable: true
                        })
                    }
                })
                .catch((err) => {
                    reset_chart()
                    setmodal_load({ enable: false, message: "" })
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: err.message,
                        enable: true
                    })
                });
        } else {
            setModal_popup({
                modaltype: 'modal-warning',
                headers: 'Warning',
                message: "Please select inverter and tag.",
                enable: true
            })
        }
    }

    async function api_getmeu() {
        setmodal_load({ enable: true, message: "Loading tags list......" })
        await sleep(500)

        const formData = new FormData();
        formData.append('sitecode', reportsite)

        axios.post(process.env.REACT_APP_API_URL + "/proxy/center/api/historical/inverterpowermenu", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    if (response.data.uioption !== null) {
                        setData_uioption(response.data.uioption)
                    }
                    if (response.data.stringlist !== null) {
                        setString_tag_list(response.data.stringlist)
                    }
                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    })
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    function export_csv() {
        if (chart_select_export.datakey !== "" && chart_plot.CSV_Data.length > 0) {
            let tableheader = ['Timestamp',
                'Irradiation (W/m2)',
                chart_select_export.display + ' (kW)',
                'Connection']

            const tableData = [];
            tableData.push(tableheader.join(","));
            for (const row of chart_plot.CSV_Data) {
                const rowData = [];
                if (row["timestamp"] !== null) {
                    if (row["timestamp"] !== "-") {
                        if (row["timestamp"] !== null) {
                            rowData.push(row["timestamp"].replaceAll(",", ""))
                        } else { rowData.push('') }

                        if (row["env.total_irr_avg"] !== null) {
                            rowData.push(row["env.total_irr_avg"])
                        } else { rowData.push('') }

                        if (row[chart_plot.Device.toLowerCase() + "." + chart_select_export.datakey] !== null) {
                            rowData.push(row[chart_plot.Device.toLowerCase() + "." + chart_select_export.datakey])
                        } else { rowData.push('') }

                        if (row[chart_plot.Device.toLowerCase() + ".conn"] !== null) {
                            rowData.push(row[chart_plot.Device.toLowerCase() + ".conn"])
                        } else { rowData.push('') }

                        tableData.push(rowData.join(","));
                    }
                }
            }

            let data = tableData.join("\n");
            const a = document.createElement("a");
            a.href = URL.createObjectURL(new Blob([data], { type: "text/csv" }));
            var fnamey = 'InverterPower_' + chart_plot.Device + '_' + chart_plot.FileName + '_' + chart_select_export.display + '.csv'
            a.setAttribute("download", fnamey);
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        } else {
            setModal_popup({
                modaltype: 'modal-warning',
                headers: 'Warning',
                message: "No data to be export",
                enable: true
            })
        }
    }

    function reset_chart() {
        setChart_plot({
            FileName: '',
            CSV_Data: [],
            XLabel: '',
            Power: [],
            IRR: [],
            Tags: chart_select.display,
            Device: inverter_item.inverter_id_text,
            Chart1_Style: {
                irr_type: "line",
                solar_type: "area",
                irr_unit: "W/m2",
                solar_unit: "kW",
                axis_y1: 'Power (kW)',
                axis_y2: 'Irradiation (W/m2)',
                xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: '-'
            }
        })
        setChart_select_export({
            datakey: '',
            display: ''
        })
    }

    function BackCenter() {
        if (props.permitdata !== null && props.permitdata !== undefined) {
            if (props.permitdata.user_mode !== null && props.permitdata.user_mode !== undefined) {
                if (props.permitdata.user_mode === "center") {
                    return <button className='back-center-btn' onClick={() => {
                        props.callback_backcenter()
                    }}>Back to Center</button>
                }
            }
        }
    }

    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="mdi mdi-table-search color-orange"></i> Inverter Power</h4>
                                    <p className="mb-0">Query your inverter power</p>
                                </div>
                                {
                                    !props.iscenter ?
                                        <div>
                                            {BackCenter()}
                                        </div>
                                        : null
                                }
                            </div>
                            <hr className="new-section-xs mb-2" />
                        </div>
                    </div>

                    <div className="d-flex gap-1 flex-wrap mb-4 print-disable">
                        {
                            props.iscenter ?
                                <div className="d-block">
                                    <label htmlFor="reportsite" className="form-label mb-0">Select Site</label>
                                    <select id="reportsite" name="reportsite" className="form-select font-sarabun" value={reportsite} onChange={(e) => {
                                        setReportsite(e.target.value)
                                    }} required>
                                        {
                                            props.permitdata !== null ?
                                                props.permitdata.sitescope_arr.map((data, index) => (
                                                    <option value={data.sitecode_txt} key={data.sitecode_txt}>{data.sitecode_txt} {data.sitename_th}</option>
                                                ))
                                                :
                                                null
                                        }
                                    </select>
                                </div>
                                : null
                        }
                        <div className="d-block " style={{ width: "160px" }}>
                            <label htmlFor="reporttype" className="form-label mb-0">Select Date</label>
                            <Calendar
                                allowClear={false}
                                className={"form-control"}
                                onChange={onCalendaraChange}
                                style={{
                                    fontFamily: "poppins",
                                    fontSize: "0.75rem",
                                    Color: "black",
                                    lineHeight: "1.5",
                                    cursor: "pointer",
                                }}
                                value={reportdate_dt}
                                disabledDate={disabledCalendar}
                            />
                        </div>
                        <div className="d-block" style={{ width: "160px" }}>
                            <label htmlFor="event_device" className="form-label mb-0">Select Inverter No.</label>
                            <select id="event_device" name="event_device" className="form-select" value={inverter_item.device_name} onChange={(e) => {
                                const found = data_uioption.device_selector.find((element) => element.device_name_raw === e.target.value);
                                if (found !== undefined) {
                                    setInverter_item({
                                        ...inverter_item,
                                        inverter_id_text: found.device_id,
                                        device_name: e.target.value,
                                        pvstring_support: found.pvstring_support
                                    })
                                } else {
                                    setInverter_item({
                                        ...inverter_item,
                                        inverter_id_text: e.target.value,
                                        device_name: '',
                                        pvstring_support: 0
                                    })
                                }
                            }} required>
                                {
                                    data_uioption.device_selector.map((device, index) => (
                                        device.table === "Inverter" ?
                                            <option key={device.device_name_raw} value={device.device_name_raw}>{device.device_id}</option>
                                            :
                                            null
                                    ))
                                }
                            </select>
                        </div>
                        <div className="d-block" style={{ width: "180px" }} >
                            <label htmlFor="plant" className="form-label mb-0">Select Tag</label>
                            <select id="plant" name="plant" className="form-select" value={chart_select.datakey} onChange={(e) => {
                                const found = string_tag_list.find((element) => element.tagname === e.target.value);
                                if (found !== undefined) {
                                    setChart_select({
                                        datakey: e.target.value,
                                        display: found.display
                                    })
                                } else {
                                    setChart_select({
                                        datakey: e.target.value,
                                        display: 'Unknown'
                                    })
                                }
                            }} required>
                                {
                                    string_tag_list.map((data, index) => (
                                        data.channel <= inverter_item.pvstring_support ?
                                            <option value={data.tagname} key={data.tagname}>{data.display}</option>
                                            :
                                            null
                                    ))
                                }
                            </select>
                        </div>
                        <div className='d-flex'>
                            <div className="d-block align-self-end print-disable" style={{ paddingBottom: "3px" }}>
                                <button className="btn btn-info btn-sm me-5" onClick={() => { api_query() }}><i className="fas fa-search "></i> Query</button>
                            </div>
                            <div className="d-block align-self-end print-disable">
                                <div className="d-flex gap-1 mt-3 mt-lg-0" style={{ marginBottom: "3px" }}>
                                    <button className="btn btn-secondary btn-sm " onClick={() => { export_csv() }}><i className="fas fa-file-csv "></i> Export CSV</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 col-xxxl-12">
                            <div className="card card-common mb-3">
                                <div className="card-body pb-3">
                                    <h5 className="card-title font-weight-bold mb-0"><i className="mdi mdi-chart-line color-sky"></i> Inverter Power Chart</h5>
                                    <div className='query-info-table mt-0'>
                                        <div className='query-info-row'>
                                            <div className='query-info-cell info-name'>Site Name</div>
                                            <div className='query-info-cell'>{chart_plot.Sitename}</div>
                                        </div>
                                        <div className='query-info-row'>
                                            <div className='query-info-cell info-name'>Device</div>
                                            <div className='query-info-cell'>{chart_plot.Device}</div>
                                        </div>
                                        <div className='query-info-row'>
                                            <div className='query-info-cell info-name'>Data Tag</div>
                                            <div className='query-info-cell'>{chart_plot.Tags}</div>
                                        </div>
                                    </div>
                                    <ChartHistory_InverterPower
                                        solorpower={chart_plot.Power}
                                        irr={chart_plot.IRR}
                                        xlabel={chart_plot.XLabel}
                                        chart_style={chart_plot.Chart1_Style}
                                        tagx={chart_plot.Tags}
                                    ></ChartHistory_InverterPower>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}
export default HistoricalDataInverterPower